import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Tooltip } from '@material-ui/core'
import { PlateOrderDetails } from './PlateOrderDetails'
import { TabContext, TabList } from '@material-ui/lab'
import Tab from '@material-ui/core/Tab'
import clsx from 'clsx'
import EditIcon from '@src/icons/EditIcon'
import { configContext } from '../Ngso'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import PlateAdditionalServices from './PlateAdditionalServices'
import EditOligoName from './EditOligoName'

const useStyles = makeStyles((theme: Theme) => {
  return {
    subHeading: {
      fontSize: theme.typography.pxToRem(14),
      fontFamily: 'Lato',
      marginRight: theme.spacing(9),
      paddingTop: theme.spacing(2),
    },
    textBold: {
      fontWeight: theme.typography.fontWeightBold,
    },
    imagewidth: {
      width: 119,
      margin: theme.spacing(4, 8, 0, 0),
    },
    tabListIndicator: {
      '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.common.black,
      },
      minHeight: 0,
    },
    tab: {
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(0),
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(1),
      color: theme.palette.primary.main,
      '& span': {
        alignItems: 'start',
      },
      minHeight: 0,
      minWidth: 'auto',
      maxWidth: '100%',
      height: theme.spacing(4),
      opacity: 1,
    },
    selected: {
      color: theme.palette.common.black,
    },
    editIcon: {
      fontSize: theme.typography.pxToRem(16),
      marginRight: theme.spacing(4),
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
    tabContent: {
      padding: theme.spacing(0),
    },
    checkbox: {
      fontSize: theme.typography.pxToRem(14),
    },
  }
})
enum NgsoPlatesData {
  Type = 'Type: ',
  NGSOSilver = 'NGSO-Silver',
  Format = 'Format: ',
  InSolution = 'In Solution (TE)',
  Yield = 'Yield: ',
  YieldValue = ' 5-10 nmole (sequence length dependent)',
  PlateFormatKey = 'Plate Format: ',
}

export const NgsoPlates = (props) => {
  const classes = useStyles()
  const { state } = React.useContext(configContext)
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [selectedPlateName, setSelectedPlateName] = React.useState()
  const [selectedPlateIndex, setSelectedPlateIndex] = React.useState()
  const { sessionData } = state
  const {
    productDetails,
    saveSessionHandler,
    totalValidation,
    clearSession,
    configuratorAddToMiniCart,
    isCSR,
  } = props
  const [value, setValue] = React.useState('0')
  const product = sessionData.length
    ? sessionData[0]?.wellList?.length
      ? sessionData[0]?.wellList[0]
      : {}
    : {}
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const changeSelectedPlate = (changedIndex) => {
    setValue(changedIndex)
  }

  const saveAnalyticHplc = (event) => {
    const { checked, value } = event.target
    sessionData.forEach((data) => {
      data.wellList.forEach((well) => {
        if (checked) {
          well.analyticalHPLC = value
        } else {
          well.analyticalHPLC = ''
        }
      })
    })
    saveSessionHandler(sessionData, true)
  }
  const saveCOA = (event) => {
    const { checked, value } = event.target
    sessionData.forEach((data) => {
      data.wellList.forEach((well) => {
        if (checked) {
          well.certificateOfAnalysis = value
        } else {
          well.certificateOfAnalysis = ''
        }
      })
    })
    saveSessionHandler(sessionData, true)
  }
  const handlePlatenameChange = (item, index) => {
    setDialogOpen(true)
    setSelectedPlateName(item)
    setSelectedPlateIndex(index)
  }
  const UpdateNewPlateName = (newname, index) => {
    sessionData[index].plateName = newname
    saveSessionHandler(sessionData, false)
  }
  const plateFormatValue = `${sessionData[0].wellType} well, ${
    sessionData[0].channelType
  } channel, ${sessionData[0].plateType.toLowerCase()}`
  return (
    <>
      <Grid container direction="row">
        <Grid item className={classes.subHeading} xs={4} direction="column">
          <span className={classes.textBold}>{NgsoPlatesData.Type}</span>
          {NgsoPlatesData.NGSOSilver}
        </Grid>
        <Grid item className={classes.subHeading} xs={4} direction="column">
          <span className={classes.textBold}>
            {NgsoPlatesData.PlateFormatKey}
          </span>
          {plateFormatValue}
        </Grid>
        <Grid item className={classes.subHeading} xs={4} direction="column">
          <span className={classes.textBold}>{NgsoPlatesData.Format}</span>
          {sessionData[Number(value)]?.wellList[0]?.format ? (
            <FormattedMessage
              {...checkValidKey(
                messages[`${sessionData[Number(value)]?.wellList[0]?.format}`],
                `${sessionData[Number(value)]?.wellList[0]?.format}`
              )}
            />
          ) : (
            '--'
          )}
        </Grid>
        <Grid item className={classes.subHeading} xs={4} direction="column">
          <span className={classes.textBold}>{NgsoPlatesData.Yield}</span>
          {NgsoPlatesData.YieldValue}
        </Grid>
      </Grid>
      <Grid container direction="row">
        {sessionData.map((data, index) => {
          return (
            <>
              <Grid item>
                <Grid>
                  <img
                    alt="plate1"
                    key={index}
                    className={classes.imagewidth}
                    src="/static/NGSO_plate_image.png.png"
                  />
                </Grid>
                <TabContext value={value}>
                  <TabList
                    onChange={handleChange}
                    className={classes.tabListIndicator}
                    value={value}
                  >
                    <Tab
                      key={index}
                      label={data.plateName}
                      value={index.toString()}
                      className={clsx(classes.tab, {
                        [classes.selected]: value === index.toString(),
                      })}
                    />
                    <Tooltip
                      title={<FormattedMessage {...messages.EDIT_PLATE_NAME} />}
                      enterDelay={1000}
                      PopperProps={{
                        style: { marginTop: -60, marginLeft: 75 },
                      }}
                    >
                      <span>
                        <EditIcon
                          className={classes.editIcon}
                          onClick={() =>
                            handlePlatenameChange(data.plateName, index)
                          }
                        />
                      </span>
                    </Tooltip>
                  </TabList>
                </TabContext>
              </Grid>
            </>
          )
        })}
        {isCSR ? (
          <Grid container>
            <PlateAdditionalServices
              product={product}
              saveCOA={saveCOA}
              saveAnalyticHplc={saveAnalyticHplc}
              productDetails={productDetails}
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid container className={classes.tabContent}>
          <PlateOrderDetails
            handlePrev={props.handlePrev}
            product={product}
            selectedPlate={Number(value)}
            productDetails={productDetails}
            sessionData={sessionData}
            saveSessionHandler={saveSessionHandler}
            changeSelectedPlate={changeSelectedPlate}
            clearSession={clearSession}
            totalValidation={totalValidation}
            configuratorAddToMiniCart={configuratorAddToMiniCart}
          />
        </Grid>
      </Grid>
      {dialogOpen && (
        <EditOligoName
          dialogOpen={dialogOpen}
          title={<FormattedMessage {...messages.EDIT_PLATE_NAME} />}
          fieldLabel={<FormattedMessage {...messages.PLATE_NAME} />}
          setDialogOpen={setDialogOpen}
          selectedName={selectedPlateName}
          selectedIndex={selectedPlateIndex}
          UpdateNewName={UpdateNewPlateName}
        />
      )}
    </>
  )
}

export default NgsoPlates
